export default __webpack_public_path__ + "src/assets/reddit.00fcf33103aa32a3fd8238b8b72969a8.svg";